import { create } from "zustand";
import i18n from "@/i18n";

export type LocaleCode = "es" | "en" | "ca" | "fr" | "it" | "de" | "nl" | "pt-br";

export const LOCALE_OPTIONS: { code: LocaleCode; label: string }[] = [
  { code: "es", label: "Español" },
  { code: "en", label: "English" },
  { code: "ca", label: "Català" },
  { code: "fr", label: "Français" },
  { code: "it", label: "Italiano" },
  { code: "de", label: "Deutsch" },
  { code: "nl", label: "Nederlands" },
  { code: "pt-br", label: "Português (BR)" },
];

interface LocaleState {
  locale: LocaleCode;
  setLocale: (lang: LocaleCode) => void;
}

function readStoredLocale(): LocaleCode {
  const raw = localStorage.getItem("rms-locale");
  if (!raw) return "es";
  // Handle legacy zustand persist format: {"state":{"locale":"en"},"version":0}
  if (raw.startsWith("{")) {
    try {
      const parsed = JSON.parse(raw);
      const code = parsed?.state?.locale ?? parsed?.locale;
      if (code && LOCALE_OPTIONS.some((o) => o.code === code)) {
        localStorage.setItem("rms-locale", code); // migrate to simple format
        return code as LocaleCode;
      }
    } catch { /* not JSON, fall through */ }
  }
  if (LOCALE_OPTIONS.some((o) => o.code === raw)) return raw as LocaleCode;
  localStorage.removeItem("rms-locale");
  return "es";
}

export const useLocaleStore = create<LocaleState>()((set) => ({
  locale: readStoredLocale(),
  setLocale: (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("rms-locale", lang);
    document.documentElement.lang = lang;
    set({ locale: lang });
  },
}));
